import $ from 'jquery';

export default function readmore() {
  $('.readmore-block').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      $(this).prev().slideToggle();
    });
  });
}
